import { render, staticRenderFns } from "./EmailRecipientsDialog.vue?vue&type=template&id=4c7c9447&scoped=true"
import script from "./EmailRecipientsDialog.vue?vue&type=script&lang=js"
export * from "./EmailRecipientsDialog.vue?vue&type=script&lang=js"
import style0 from "./EmailRecipientsDialog.vue?vue&type=style&index=0&id=4c7c9447&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7c9447",
  null
  
)

export default component.exports